import { UiButtonBase } from "@smp/ui";
import { IconSearch } from "@tabler/icons-react";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { HelperAdapterLink } from "@/components/helpers/helper_adapter_link";
import { useSmpAgTranslation } from "@/hooks/use_smp_ag_translation";
import { useQueryPolotnoTagsAll } from "@/queries/polotno/use_query_polotno_tags_all";
import { customGeneratePath } from "@/utils";

import { useContextPolotnoTemplates } from "../../context";
import { useStyles } from "./tag_button.css";

export const TagButton = ({
  slug,
  backUrl,
  showIcon,
}: {
  slug: string;
  backUrl: string;
  showIcon?: boolean;
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const getTranslation = useSmpAgTranslation();

  const {
    state: { pathPattern, isRoutingDisabled },
    actions: { updateSelectedTags, setActiveEntity },
  } = useContextPolotnoTemplates();

  const {
    data: { normalized: normalizedTags },
  } = useQueryPolotnoTagsAll();

  const tag = useMemo(() => normalizedTags?.get(slug), [normalizedTags, slug]);

  const handleClick = useCallback(() => {
    if (!tag?.parent) {
      return;
    }

    updateSelectedTags(tag.parent, tag.slug);

    setActiveEntity(undefined);

    if (!isRoutingDisabled) {
      navigate(customGeneratePath(pathPattern));
    }
  }, [
    isRoutingDisabled,
    navigate,
    pathPattern,
    setActiveEntity,
    tag?.parent,
    tag?.slug,
    updateSelectedTags,
  ]);

  if (!tag) {
    return null;
  }

  return (
    <UiButtonBase
      className={classes.button}
      onClick={handleClick}
      component={!isRoutingDisabled ? HelperAdapterLink : undefined}
      to={!isRoutingDisabled ? backUrl : undefined}
    >
      {showIcon && <IconSearch className={classes.icon} />}
      {getTranslation(tag.translations)}
    </UiButtonBase>
  );
};
